module.exports = __webpack_public_path__ + "static/media/fog.8d7922e7.svg";